// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__34h4q","question":"Question_question__BB8W-","description":"Question_description__2aYmy"};